import { Component, OnInit } from '@angular/core';
import { DwComponent, DwComponentType } from '@devwareapps/devware-cap';

@DwComponent({
  key: 'app-placeholder-menu',
   name: 'Placeholder Menu',
   isGlobal: true,
   componentType: DwComponentType.menuComponent
})
@Component({
  selector: 'app-placeholder-menu',
  template: `
   
  `
})
export class PlaceholderMenuComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
